import { Injectable } from '@angular/core';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class ProductDescriptionHomologationService {
  constructor(private featureToggle: FeatureToggleService) {}
  isEnabled(): boolean {
    return this.featureToggle.isFeatureEnabled(Features.ProductDescriptionHomologation);
  }
}
